module.exports = __webpack_public_path__ + "static/media/ODS02.f6c6744e.jpg";